// src/components/Footer.jsx
// Discreet legal footer, mounted globally once in AuthHandler (covers Login + all
// logged-in screens). No react-router hooks: every link is a plain <a>, so it is
// safe to mount anywhere. External docs open in a new tab; /deletion-status is a
// Firebase hosting rewrite to a Cloud Function, so it needs a full-page navigation
// (plain anchor, same tab) — NOT a react-router Link.
import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="legal-footer">
      <nav aria-label="Legal">
        <a href="https://pux.app/terms" target="_blank" rel="noopener noreferrer">Términos</a>
        <span className="sep" aria-hidden="true">·</span>
        <a href="https://pux.app/privacy" target="_blank" rel="noopener noreferrer">Privacidad</a>
        <span className="sep" aria-hidden="true">·</span>
        <a href="https://pux.app/ai-transparency" target="_blank" rel="noopener noreferrer">Transparencia de IA</a>
        <span className="sep" aria-hidden="true">·</span>
        <a href="mailto:contacto@pux.app">contacto@pux.app</a>
        <span className="sep" aria-hidden="true">·</span>
        <a href="/deletion-status">Eliminación de datos</a>
      </nav>
    </footer>
  );
}
